import React, { useEffect, useRef, useState } from "react";

const ExportButton = ({ onExport, isExporting, size }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const btnClass = `btn btn-outline-success${size ? ` btn-${size}` : ""} dropdown-toggle`;

  return (
    <div className={`btn-group${size ? ` btn-${size}` : ""}`} ref={ref}>
      <button type="button" className={btnClass} onClick={() => setOpen(!open)} disabled={isExporting}>
        <i className={`bi bi-${isExporting ? "hourglass-split" : "download"} me-1`}></i>
        Export
      </button>
      <ul className={`dropdown-menu dropdown-menu-end${open ? " show" : ""}`}>
        <li>
          <button className="dropdown-item" onClick={() => { onExport("csv"); setOpen(false); }}>CSV</button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => { onExport("xlsx"); setOpen(false); }}>Excel (XLSX)</button>
        </li>
      </ul>
    </div>
  );
};

export default ExportButton;